/* @ngInject */
const validator = (
  $q,
  entities,
  $timeout
) => {
  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      validator: '=',
    },
    link: (scope, elm, attrs, ctrl) => {
      if (scope.validator) {
        ctrl.$asyncValidators.exists = (modelValue, viewValue) => {
          return $q((resolve, reject) => {
            $timeout(async () => {
              const nature = scope.validator.nature
              const ref = scope.validator.ref
              const oldValue = scope.validator.oldValue || ''

              if (modelValue && oldValue.toLowerCase() !== modelValue.toLowerCase()) {
                const searchdata = {
                  [ref]: modelValue,
                }
                try {
                  const response = await entities[nature].request.getBySearch(searchdata)
                  if (response.color === 'green') {
                    reject()
                  } else {
                    resolve()
                  }
                } catch (error) {
                  resolve()
                }
              } else {
                resolve()
              }
            }, 200)
          })
        }
      }
    },
  }
}

export default validator



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/validator.js